<template>
  <div ref="winnersBox"
    class="w-full h-full flex-grow p-3 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm bg-stone-100 dark:bg-stone-700 dark:text-stone-200 overflow-auto font-sans"
    spellcheck="false" />
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useWheelStore } from '@/stores/useWheelStore';
import * as Util from '@utils/Util.js';

const winnersBox = ref(null);
const wheelStore = useWheelStore();
const winners = computed(() => wheelStore.winners);

function updateWinnersList() {
  const div = winnersBox.value;
  if (div && winners.value) {
    div.innerHTML = winners.value.map(entry => Util.renderEntry(entry)).join('');
  }
}

onMounted(() => {
  updateWinnersList();
});

watch(winners, () => {
  updateWinnersList();
}, { immediate: true });
</script>

<style scoped>
/* All styles converted to Tailwind utility classes */
</style>
